import { render } from "./ProsesLayerPeta.vue?vue&type=template&id=8ffde11c"
import script from "./ProsesLayerPeta.vue?vue&type=script&lang=js"
export * from "./ProsesLayerPeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__